/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../buttons/link/link.component.ngfactory';
import * as import2 from '../../buttons/link/link.component';
import * as import3 from '../../orchestration/responsive.directive';
import * as import4 from '../../orchestration/responsive.service';
import * as import5 from '../../orchestration/navigation.service';
import * as import6 from '@angular/common';
import * as import7 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import8 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import9 from '../../orchestration/page';
import * as import10 from './store-details-page.component';
import * as import11 from '../store-details-panel/store-details-panel.component.ngfactory';
import * as import12 from '../store-details-panel/store-details-panel.component';
import * as import13 from '../../orchestration/session.model';
import * as import14 from '../../ordering-context/ordering-context.model';
import * as import15 from '../../orchestration/navigation-params';
const styles_StoreDetailsPageComponent:any[] = ([] as any[]);
export const RenderType_StoreDetailsPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_StoreDetailsPageComponent,
  data: {}
}
);
function View_StoreDetailsPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.changeOrderType(co.OrderType.ORDER_AHEAD)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_LinkComponent_0,import1.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import2.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.ordering-context.show-store-details.orderAhead';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_StoreDetailsPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.changeOrderType(co.OrderType.ORDER_DELIVERY)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_LinkComponent_0,import1.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import2.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.ordering-context.show-store-details.delivery';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_StoreDetailsPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.changeOrderType(co.OrderType.ORDER_AT_TABLE)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_LinkComponent_0,import1.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import2.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.ordering-context.show-store-details.orderAtTable';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_StoreDetailsPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[
      [
        'class',
        'store-details-header'
      ]
      ,
      [
        'slot',
        'header'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(737280,(null as any),0,import3.ResponsiveDirective,[
      import0.ElementRef,
      import4.ResponsiveService,
      import5.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreDetailsPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    ck(v,1,0);
    const currVal_0:any = (co.orderAheadStoreOption && (co.orderType !== co.OrderType.ORDER_AHEAD));
    ck(v,4,0,currVal_0);
    const currVal_1:any = (co.orderDeliveryStoreOption && (co.orderType !== co.OrderType.ORDER_DELIVERY));
    ck(v,7,0,currVal_1);
    const currVal_2:any = (co.orderAtTableStoreOption && (co.orderType !== co.OrderType.ORDER_AT_TABLE));
    ck(v,10,0,currVal_2);
  },(null as any));
}
export function View_StoreDetailsPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import7.View_ModalPageLayoutComponent_0,import7.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import8.ModalPageLayoutComponent,[
      import9.Page,
      import5.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      customGeometry: [
        1,
        'customGeometry'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
    import0.ɵpid(131072,import6.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod([
      'pillarboxedOnDesktop',
      'width',
      'height'
    ]
    ),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import9.PageLayout,(null as any),[import8.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),2,1,(null as any),View_StoreDetailsPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,1,'woa-store-details-panel',([] as any[]),(null as any),[[
        (null as any),
        'onOrderFromStore'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.StoreDetailsPageComponent = v.component;
      if (('onOrderFromStore' === en)) {
        const pd_0:any = ((<any>co.orderFromStore($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import11.View_StoreDetailsPanelComponent_0,import11.RenderType_StoreDetailsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import12.StoreDetailsPanelComponent,[
      import13.SessionModel,
      import4.ResponsiveService,
      import14.OrderingContextModel,
      import0.ChangeDetectorRef
    ]
    ,{
      store: [
        0,
        'store'
      ]
      ,
      intention: [
        1,
        'intention'
      ]
      ,
      filteredOrderType: [
        2,
        'filteredOrderType'
      ]
      ,
      showStoreImage: [
        3,
        'showStoreImage'
      ]
      ,
      showTelephone: [
        4,
        'showTelephone'
      ]
      ,
      showMoreDetails: [
        5,
        'showMoreDetails'
      ]
      ,
      showMap: [
        6,
        'showMap'
      ]

    }
    ,{onOrderFromStore: 'onOrderFromStore'}),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import10.StoreDetailsPageComponent = v.component;
    const currVal_0:any = co.title;
    const currVal_1:any = (import0.ɵunv(v,2,1,import0.ɵnov(v,5).transform(co.responsiveService.mobile$))? (undefined as any): ck(v,6,0,'none','800px','500px'));
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_2:any = co.showStoreOrderTypeOptions;
    ck(v,10,0,currVal_2);
    const currVal_3:any = co.store;
    const currVal_4:any = co.intention;
    const currVal_5:any = co.orderingContext.selectedOrderType;
    const currVal_6:any = false;
    const currVal_7:any = true;
    const currVal_8:any = false;
    const currVal_9:any = true;
    ck(v,13,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
  },(null as any));
}
function View_StoreDetailsPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-store-details-page',([] as any[]),(null as any),(null as any),(null as any),View_StoreDetailsPageComponent_0,RenderType_StoreDetailsPageComponent)),
    import0.ɵdid(49152,(null as any),0,import10.StoreDetailsPageComponent,[
      import15.NavigationParams,
      import14.OrderingContextModel,
      import5.NavigationService,
      import4.ResponsiveService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import9.Page,(null as any),[import10.StoreDetailsPageComponent])
  ]
  ,(null as any),(null as any));
}
export const StoreDetailsPageComponentNgFactory:import0.ComponentFactory<import10.StoreDetailsPageComponent> = import0.ɵccf('woa-store-details-page',import10.StoreDetailsPageComponent,View_StoreDetailsPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/store/store-details-page/store-details-page.component.ngfactory.ts